import LegalPageLayout from "./LegalPageLayout";

export default function PolitiquePage() {
  return (
    <LegalPageLayout
      title="Politique de confidentialité"
      subtitle="Dernière mise à jour : décembre 2025"
      testid="page-politique"
    >
      <section>
        <p>
          Chez Echo, la protection de tes données personnelles est une priorité. Cette politique
          explique quelles informations nous collectons, comment nous les utilisons et quels sont
          tes droits.
        </p>
      </section>

      <section>
        <h2>1. Données collectées</h2>
        <p>Nous collectons uniquement les données strictement nécessaires au fonctionnement de l&apos;application :</p>
        <ul>
          <li>Adresse email lors de la création d&apos;un compte</li>
          <li>Préférences et paramètres de programme personnalisé</li>
          <li>Progression, statistiques d&apos;utilisation et récompenses gagnées</li>
          <li>Données techniques anonymisées (type d&apos;appareil, version de l&apos;application)</li>
        </ul>
      </section>

      <section>
        <h2>2. Utilisation des données</h2>
        <p>Tes données servent uniquement à :</p>
        <ul>
          <li>Te fournir un programme personnalisé de glow up mental</li>
          <li>Suivre ta progression et te faire gagner des récompenses</li>
          <li>Améliorer la qualité de l&apos;application</li>
          <li>Te contacter en cas de besoin lié à ton compte</li>
        </ul>
      </section>

      <section>
        <h2>3. Partage des données</h2>
        <p>
          Nous ne vendons ni ne louons tes données personnelles à des tiers. Elles peuvent être
          partagées uniquement avec nos sous-traitants techniques (hébergement, envoi d&apos;emails),
          sous obligation stricte de confidentialité et conformément au RGPD.
        </p>
      </section>

      <section>
        <h2>4. Conservation</h2>
        <p>
          Tes données sont conservées tant que ton compte est actif. Tu peux demander leur suppression
          à tout moment en nous écrivant à <strong>support@theecho.fr</strong>.
        </p>
      </section>

      <section>
        <h2>5. Tes droits</h2>
        <p>Conformément au RGPD, tu disposes d&apos;un droit :</p>
        <ul>
          <li>D&apos;accès à tes données</li>
          <li>De rectification</li>
          <li>De suppression (droit à l&apos;oubli)</li>
          <li>D&apos;opposition et de limitation du traitement</li>
          <li>À la portabilité de tes données</li>
        </ul>
        <p>Pour exercer ces droits, contacte-nous à <strong>support@theecho.fr</strong>.</p>
      </section>

      <section>
        <h2>6. Sécurité</h2>
        <p>
          Nous mettons en œuvre des mesures techniques et organisationnelles pour protéger tes
          données contre tout accès non autorisé, altération ou perte.
        </p>
      </section>
    </LegalPageLayout>
  );
}
